import React, { useEffect, useState } from "react";
import general from "../../general";
import { CloseOutlined } from "@ant-design/icons";
import $ from "jquery";
import { Link } from "react-router-dom";
import { useDebounceEffect } from "ahooks";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import { splitStr } from "../../utils/commonFunc";
import dayjs from "dayjs";
import { sortEncodeAndHash } from "../../utils/signFunc";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";

// 搜索结果展示
export default ({
  active,
  boardkw,
  setBoardkw,
  gamekw,
  setGamekw,
  classifyId,
  setClassifyId,
  type,
  setType,
  refresh,
  gameList,
  historySearch,
  setHistorySearch,
}) => {
  let [init, setInit] = useState(false);
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);

  const [isServerShutdown, setIsServerShutdown] = useState(false);
  const [gameSearchCategories, setGameSearchCategories] = useState([]);

  // 获取搜索游戏列表
  const getBoardGameList = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();

    // 获取分类对应游戏列表
    if (classifyId) {
      setGameSearchCategories([]);

      let tmp = {
        categorize_id: classifyId,
        categorize_type: "def",
        page: page,
        page_size: 20,
      };
      if (parms.page) {
        tmp.page = parms.page;
      }

      general.axios
        .post("/v3/base/appcategorize/getAppCategorizeData", tmp)
        .finally(() => {
          setLoading(false);
          Dialog.close();
        })
        .then((response) => {
          console.log("搜索结果--", response);

          let result = response.data.data;
          if (parms.page) {
            setPage(parms.page);
          }
          let datas = result?.two?.game || result?.three?.game || [];

          setGames((prevGames) =>
            parms.page === 1 || !parms.page ? datas : [...prevGames, ...datas],
          );

          // 检查是否还有更多数据
          const hasMore = datas?.length >= 20; // 如果返回的数据等于page_size，说明可能还有更多
          setMore(hasMore);

          setInit(true);
        })
        .catch((err) => {
          Dialog.error(err.message);
        });
    } else {
      let tmp = {
        word: gamekw.trim(),
        type,
        page: page,
        page_size: 20,
      };
      if (parms.page) {
        tmp.page = parms.page;
      }

      let time = dayjs().unix().toString();

      general.axios
        .post("/v4/search/list", tmp, {
          headers: {
            sign: sortEncodeAndHash({
              ...tmp,
              timestamp: time,
            }),
            timestamp: time,
          },
        })
        .finally(() => {
          setLoading(false);
          Dialog.close();
        })
        .then((response) => {
          console.log("搜索结果--", response);

          if (response.data.code !== 200) {
            if (response.data.msg == "已关服下架") {
              setIsServerShutdown(true);
            } else {
              setIsServerShutdown(false);
              Dialog.error(response.data.message || response.data.msg);
              return;
            }
          } else {
            setIsServerShutdown(false);
          }

          let result = response.data.data;
          if (parms.page) {
            setPage(parms.page);
          }
          let datas = result.list;

          setGameSearchCategories(result.gameCategories);

          setGames((prevGames) => {
            const newGames =
              parms.page === 1 || !parms.page
                ? datas
                : [...prevGames, ...datas];

            return newGames;
          });

          // 检查是否还有更多数据
          const hasMore = datas?.length >= 20; // 如果返回的数据等于page_size，说明可能还有更多
          setMore(hasMore);

          setInit(true);
        })
        .catch((err) => {
          Dialog.error(err.message);
        });
    }
  };

  // 获取关联词列表
  const [conjunctionsInit, setConjunctionsInit] = useState(false);
  const [conjunctionsLoading, setConjunctionsLoading] = useState();
  const [conjunctionsPage, setConjunctionsPage] = useState(1);
  let [conjunctionsGames, setConjunctionsGames] = useState([]);
  const [conjunctionsMore, setConjunctionsMore] = useState(true);

  const [recommendGames, setRecommendGames] = useState([]);
  const [gameCategories, setGameCategories] = useState([]);
  const getConjunctionsList = (parms = {}) => {
    if (conjunctionsLoading) {
      return;
    }
    setConjunctionsLoading(true);
    Dialog.loading();

    let tmp = {
      word: boardkw.trim(),
      page: conjunctionsPage,
      page_size: 20,
    };
    if (parms.page) {
      tmp.page = parms.page;
    }

    let time = dayjs().unix().toString();

    general.axios
      .post("/v4/search/suggestion", tmp, {
        headers: {
          sign: sortEncodeAndHash({
            ...tmp,
            timestamp: time,
          }),
          timestamp: time,
        },
      })
      .finally(() => {
        setConjunctionsLoading(false);
        Dialog.close();
      })
      .then((response) => {
        console.log("关联词第二部分结果--", response);

        if (response.data.code !== 200) {
          Dialog.error(response.data.message || response.data.msg);
          return;
        }

        let result = response.data.data;
        if (parms.page) {
          setConjunctionsPage(parms.page);
        }
        let datas = result.list;

        setConjunctionsGames((prevConjunctionsGames) =>
          parms.page === 1 || !parms.page
            ? datas
            : [...prevConjunctionsGames, ...datas],
        );

        setConjunctionsMore(datas?.length > 0);

        setConjunctionsInit(true);
      })
      .catch((err) => {
        Dialog.error(err.message);
      });
  };

  const getRecommendGames = () => {
    let time = dayjs().unix().toString();
    general.axios
      .post(
        "/v4/search/recommend",
        {
          word: boardkw,
        },
        {
          headers: {
            sign: sortEncodeAndHash({
              word: boardkw,
              timestamp: time,
            }),
            timestamp: time,
          },
        },
      )
      .then((response) => {
        console.log("关联词第一部分结果--", response);

        if (response.data.code !== 200) {
          Dialog.error(response.data.message || response.data.msg);
          return;
        }

        let result = response.data.data;

        setRecommendGames(result.recommendGames);
        setGameCategories(result.gameCategories);
      })
      .catch((err) => {
        Dialog.error(err.message);
      });
  };

  let [clickNum, setClickNum] = useState(0);
  useDebounceEffect(
    () => {
      clickNum = 0;
      setClickNum(0);
      setBoardResIsClick(false);
      // 获取搜索游戏列表
      if (gamekw) {
        console.log("要获取第一页的游戏数据啦");

        getBoardGameList({ page: 1 });

        $("html,body").animate({ scrollTop: 0 }, 300);
      } else {
        setGames([]);
      }

      // 获取关联词列表
      if (boardkw) {
        getRecommendGames();
        getConjunctionsList({ page: 1 });

        $("html,body").animate({ scrollTop: 0 }, 300);
      } else {
        setRecommendGames([]);
      }
    },
    [boardkw, refresh, gamekw, classifyId],
    { wait: 500 },
  );

  useEffect(() => {
    if (gamekw) {
      setInit(false);
    }
  }, [boardkw, refresh, gamekw]);

  // 使用Intersection Observer实现底部元素可见性检测
  const [loadMoreRef, setLoadMoreRef] = useState(null);
  const [conjunctionsLoadMoreRef, setConjunctionsLoadMoreRef] = useState(null);

  useEffect(() => {
    if (!loadMoreRef || !active || !init) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && more && gamekw) {
          getBoardGameList({ page: page + 1 });
        }
      },
      {
        threshold: 0,
        rootMargin: "0px",
      },
    );

    observer.observe(loadMoreRef);

    return () => {
      observer.disconnect();
    };
  }, [loadMoreRef, active, init, more, gamekw, page]);

  useEffect(() => {
    if (!conjunctionsLoadMoreRef || !active || !conjunctionsInit) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && conjunctionsMore && boardkw) {
          console.log("底部元素可见，加载更多关联词数据");
          getConjunctionsList({ page: conjunctionsPage + 1 });
        }
      },
      {
        threshold: 0.1,
        rootMargin: "20px",
      },
    );

    observer.observe(conjunctionsLoadMoreRef);

    return () => {
      observer.disconnect();
    };
  }, [
    conjunctionsLoadMoreRef,
    active,
    conjunctionsInit,
    conjunctionsMore,
    boardkw,
    conjunctionsPage,
  ]);

  let [applyName, setApplyName] = useState("");
  const [applyShow, setApplyShow] = useState(false);
  // 提交心仪游戏
  const submitLikeGame = () => {
    if (!applyName) {
      Dialog.error("请输入游戏名称");
      return;
    }

    general.axios
      .post("/v3/base/game/searchAdd", {
        gamename: applyName,
      })
      .then((res) => {
        setApplyShow(false);

        let { status, data } = res.data;
        console.log("提交心仪游戏结果", data);
        if (!status.succeed) {
          return;
        }

        Dialog.success("提交成功，请随时关注游戏更新情况");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // 3级输入搜索词、4级点击搜索联想词同时上报
  const searchAssociationClick = async (action_code, gameInfo) => {
    // 多次点击联想词时 只进行一次搜索词上报
    if (!boardResIsClick) {
      // 同步生成三级kid
      let kid = await getKidCallback();
      sessionStorage.setItem("searchThirdKid", kid);

      // 行为上报
      // 一级kid、二级kid都进行传递
      let reamrk = {
        search_time: dayjs().unix(),
        search_term: boardkw,
      };
      userClickReport({
        target_id: 1,
        parent_id: sessionStorage.getItem("boxSecondKid"),
        kid,
        level: 3,
        action_code: "search_input",
        remark: JSON.stringify(reamrk),
      });
    }
    setBoardResIsClick(true);

    // 四级点击联想词上报
    let kidFourth = await getKidCallback();
    // 点击搜索结果上报时的 父级kid
    sessionStorage.setItem("searchResultParentKid", kidFourth);

    if (action_code == "推荐游戏") {
      // 下载上报时的 父级kid
      sessionStorage.setItem("downParentKid", kidFourth);
    } else {
      sessionStorage.removeItem("downParentKid");
    }

    // 行为上报
    let reamrkFourth = {
      search_suggest_categorize: action_code,
      search_suggest_click: gameInfo.mainName,
      search_suggest_click_time: dayjs().unix(),
      search_suggest_game_status: Number(gameInfo.status),
    };
    userClickReport({
      target_id: 1,
      parent_id: sessionStorage.getItem("searchThirdKid"),
      kid: kidFourth,
      level: 4,
      action_code: "search_suggest_click",
      remark: JSON.stringify(reamrkFourth),
    });
  };

  // 搜索结果点击上报
  const searchResultClick = async (data) => {
    let kid = await getKidCallback();
    // 下载上报时的 父级kid
    sessionStorage.setItem("downParentKid", kid);

    let reamrk = {
      game_click_time: Number(dayjs().unix()),
      game_click: data.gameName,
      game_status: Number(data.status),
      game_position: Number(data.position),
      game_click_num: Number(data.clickNum),
    };
    userClickReport({
      target_id: 1,
      parent_id: sessionStorage.getItem("searchResultParentKid"),
      kid,
      level: 5,
      action_code: "search_game_click",
      remark: JSON.stringify(reamrk),
    });
    sessionStorage.setItem("clickGameId", data.gameId);
  };

  const [boardResIsClick, setBoardResIsClick] = useState(false);

  return (
    <div className={"search-result " + (boardkw || gamekw ? "active" : "")}>
      {/* 搜索游戏列表 */}
      {gamekw && (
        <>
          {gameSearchCategories && gameSearchCategories.length > 0 && (
            <div className="game-search-categories">
              <span style={{ paddingBottom: "2px" }}>
                根据当前搜索词为你展示
                <span className="game-search-categories-title">
                  “
                  {gameSearchCategories
                    .map((category) => category.title)
                    .join(",")}
                  ”
                </span>
                分类游戏
              </span>
              {gameSearchCategories.map((category) => (
                <div
                  key={category.id}
                  className="game-search-categories-item"
                  onClick={() => {
                    setBoardkw("");
                    setType(2);
                    setGamekw(category.title);
                    setClassifyId(category.id);
                    setInit(false);
                  }}
                >
                  <span>继续搜索</span>
                  <span className="game-search-categories-item-title">
                    “{category.title}”
                  </span>
                  <img src="/resources/search/ranking-right.png" alt="" />
                </div>
              ))}
            </div>
          )}

          {games?.map((game, index) => (
            <Link
              key={game.appinfo_id || game.gameId || game.game_id}
              to={
                "/game?isSearchLink=1&mid=" +
                (game.appinfo_id || game.gameId || game.maiyou_gameid)
              }
              className="game-list-global-type"
              onClick={() => {
                clickNum++;
                setClickNum(clickNum);
                let list = historySearch;
                console.log(list);

                list.unshift(game.mainName || game.game_name_main);
                let uniqueArr = [...new Set(list)];
                if (uniqueArr.length > 10) {
                  uniqueArr.pop();
                }
                console.log("list~~~", uniqueArr);

                localStorage.setItem(
                  "search-page-history",
                  JSON.stringify(uniqueArr),
                );
                setHistorySearch(uniqueArr);

                searchResultClick({
                  gameId: game.appinfo_id || game.gameId || game.maiyou_gameid,
                  gameName:
                    game.game_name ||
                    game.mainName + (game.secondName && `-${game.secondName}`),
                  status: game.status || game.game_status,
                  position: index + 1,
                  clickNum,
                });
              }}
            >
              <div className="game-list-global-type-left">
                <div className="icon">
                  <Image src={game.logo || game.icon} />
                </div>
                <div className="data">
                  <div className="name">
                    <div className="name-main">
                      {game.mainName || game.game_name_main}
                    </div>

                    {(game.isSpecialServerGame == 2 ||
                      game?.game_tags?.is_special_server_game == 2) && (
                      <div className="dedicated-server">专服</div>
                    )}

                    {game.isHot == 1 && (
                      <img
                        style={{ height: "18px" }}
                        className="conjunctions-game-tag"
                        src="/resources/search/hot.png"
                        alt=""
                      />
                    )}
                  </div>

                  <div className="desc">
                    {splitStr(classifyId ? game.version : game.versionCode)}
                    {(game.secondName || game.game_name_branch) && (
                      <>
                        <div className="circle"></div>
                        {game.secondName || game.game_name_branch}
                      </>
                    )}
                  </div>

                  <div className="info">
                    {(game.version || game.benefits) && (
                      <>
                        {game?.is_trial_game == 2 || game?.isTrialGame == 2 ? (
                          <>
                            <div className="play-tag">有奖试玩</div>
                            {(classifyId ? game.benefits : game.version)
                              ?.split("+")
                              ?.slice(0, 1)
                              ?.map((item, index) => (
                                <div key={index} className="tag">
                                  {item}
                                </div>
                              ))}
                          </>
                        ) : (
                          (classifyId ? game.benefits : game.version)
                            ?.split("+")
                            ?.slice(0, 2)
                            ?.map((item, index) => (
                              <div key={index} className="tag">
                                {item}
                              </div>
                            ))
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {game.isPremiumGame == 2 ||
              game?.game_tags?.is_premium_game == 2 ? (
                <div
                  className="is-premium"
                  style={{
                    backgroundImage: "url('/resources/common/boutique.png')",
                  }}
                >
                  {game.discount < 1 ? (
                    <p className="is-premium-discount">
                      {parseFloat((game.discount * 10).toFixed(2))}折
                    </p>
                  ) : null}
                  <p className="boutique">精品游戏</p>
                </div>
              ) : game.isFreeVersion == 2 ||
                game?.game_tags?.is_free_version == 2 ? (
                <div className="is-free-version">
                  <span>免费版</span>
                </div>
              ) : (
                <>
                  {game.discount < 1 ? (
                    <div className="discount">
                      {parseFloat((game.discount * 10).toFixed(2))}折
                    </div>
                  ) : null}
                </>
              )}
            </Link>
          ))}

          {games?.length === 0 && init ? (
            <>
              {isServerShutdown ? (
                <div className="search-empty">
                  <p>
                    您好，“
                    <span style={{ fontWeight: "bold", color: "red" }}>
                      {gamekw}
                    </span>
                    ”已全网关服下架。
                  </p>
                  建议您试玩其他游戏，谢谢！
                </div>
              ) : (
                <div className="search-empty">
                  "{gamekw}"搜索无结果 ，推荐
                  <br />
                  试玩下方推荐游戏
                </div>
              )}

              <div>
                {gameList?.length > 0 &&
                  gameList.map((game) => (
                    <Link
                      key={game.game_id}
                      to={"/game?id=" + game.game_id}
                      className="game-list-global-type"
                      // onClick={async () => {
                      //   sessionStorage.setItem(
                      //     "downParentKid",
                      //     sessionStorage.getItem("searchResultParentKid")
                      //   );
                      //   sessionStorage.setItem(
                      //     "clickGameId",
                      //     game.maiyou_gameid
                      //   );
                      // }}
                    >
                      <div className="game-list-global-type-left">
                        <div className="icon">
                          <Image src={game?.game_image?.thumb} />
                        </div>
                        <div className="data">
                          <div className="name">
                            <div className="name-main">
                              {game.game_name_main || game.game_name}
                            </div>

                            {game?.game_tags?.is_special_server_game == 2 && (
                              <div
                                className="dedicated-server"
                                style={{ fontSize: "0.18rem" }}
                              >
                                专服
                              </div>
                            )}
                          </div>

                          <div className="desc">
                            {game.game_classify_type}
                            {game.game_name_branch && (
                              <>
                                <div className="circle"></div>
                                {game.game_name_branch}
                              </>
                            )}
                          </div>

                          <div className="info">
                            {game.game_desc && (
                              <>
                                {game?.is_trial_game == 2 ? (
                                  <>
                                    <div className="play-tag">有奖试玩</div>
                                    {game.game_desc
                                      ?.split("+")
                                      ?.slice(0, 1)
                                      ?.map((item, index) => (
                                        <div key={index} className="tag">
                                          {item}
                                        </div>
                                      ))}
                                  </>
                                ) : (
                                  game.game_desc
                                    ?.split("+")
                                    ?.slice(0, 2)
                                    ?.map((item, index) => (
                                      <div key={index} className="tag">
                                        {item}
                                      </div>
                                    ))
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      {game?.game_tags?.is_premium_game == 2 ? (
                        <div
                          className="is-premium"
                          style={{
                            height: "0.62rem",
                            padding: "0 0.26rem",
                            marginRight: "15px",
                            backgroundImage:
                              "url('/resources/common/boutique.png')",
                          }}
                        >
                          {game.discount < 1 ? (
                            <p
                              className="is-premium-discount"
                              style={{ fontSize: "0.22rem" }}
                            >
                              {parseFloat((game.discount * 10).toFixed(2))}折
                            </p>
                          ) : null}
                          <p className="boutique">精品游戏</p>
                        </div>
                      ) : game?.game_tags?.is_free_version == 2 ? (
                        <div
                          className="is-free-version"
                          style={{ marginRight: "33px" }}
                        >
                          <span>免费版</span>
                        </div>
                      ) : (
                        <>
                          {game.discount < 1 ? (
                            <div
                              className="discount"
                              style={{ marginRight: "27px" }}
                            >
                              {parseFloat((game.discount * 10).toFixed(2))}折
                            </div>
                          ) : null}
                        </>
                      )}
                    </Link>
                  ))}
              </div>

              <Link to="/?tab=top">
                <div className="ranking-font">
                  <img
                    src="/resources/search/ranking.png"
                    alt=""
                    className="icon"
                  />
                  <span>全网福利游戏排行榜</span>
                  <img
                    src="/resources/search/ranking-right.png"
                    alt=""
                    style={{ width: "12px", height: "12px", marginLeft: "2px" }}
                  />
                </div>
              </Link>
            </>
          ) : null}
          {games?.length > 0 && !more ? (
            <div className="view-end" style={{ paddingBottom: "90px" }}>
              别撩啦！已经到底啦~
            </div>
          ) : null}

          {/* 加载更多触发元素 */}
          {games?.length > 0 && (
            <div
              ref={setLoadMoreRef}
              style={{
                height: "20px",
                width: "100%",
                background: "transparent",
              }}
            />
          )}
        </>
      )}

      {/* 关联词列表 */}
      {boardkw && (
        <div className="boardkw-recommend-list">
          {recommendGames?.map((game) => (
            <Link
              key={game.gameId}
              to={"/game?isSearchLink=1&mid=" + game.gameId}
              className="game-list-global-type"
              style={{
                paddingLeft: "3px",
                paddingRight: "26px",
                marginTop: "16px",
                marginBottom: "8px",
              }}
              onClick={() => {
                // 联想词点击上报-推荐游戏
                sessionStorage.removeItem("boardInputFont");
                let list = historySearch;
                console.log(list);

                list.unshift(game.mainName);
                let uniqueArr = [...new Set(list)];
                if (uniqueArr.length > 10) {
                  uniqueArr.pop();
                }
                console.log("list~~~", uniqueArr);

                localStorage.setItem(
                  "search-page-history",
                  JSON.stringify(uniqueArr),
                );
                setHistorySearch(uniqueArr);

                sessionStorage.setItem("clickGameId", game.gameId);
                // 3级输入搜索词、4级点击搜索联想词同时上报
                searchAssociationClick("推荐游戏", {
                  mainName:
                    game.mainName + (game.secondName && `-${game.secondName}`),
                  status: game.status,
                });
              }}
            >
              <div className="game-list-global-type-left">
                <div className="icon" style={{ marginRight: "12px" }}>
                  <Image src={game.logo} />
                </div>
                <div className="data">
                  <div className="name" style={{ marginBottom: "14px" }}>
                    <div className="name-main">{game.mainName}</div>
                  </div>

                  <div className="desc" style={{ marginBottom: 0 }}>
                    {splitStr(game.versionCode)}
                    {game.secondName && (
                      <>
                        <div className="circle"></div>
                        {game.secondName}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {game.discount < 1 ? (
                <div className="discount" style={{ marginRight: 0 }}>
                  {parseFloat((game.discount * 10).toFixed(2))}折
                </div>
              ) : null}
            </Link>
          ))}

          {gameCategories?.map((category) => (
            <div
              className="game-category"
              key={category.id}
              onClick={() => {
                // 联想词点击上报-分类
                sessionStorage.removeItem("boardInputFont");
                setBoardkw("");
                setType(2);
                setGamekw(category.title);
                setClassifyId(category.id);

                // 3级输入搜索词、4级点击搜索联想词同时上报
                searchAssociationClick("分类", {
                  mainName: category.title,
                  status: "0",
                });
              }}
            >
              <img
                className="game-category-icon"
                src="/resources/search/game.png"
                alt=""
              />
              <span className="game-category-title">{category.title}</span>
              <span className="game-category-desc">
                {category.title}分类热门游戏一览
              </span>
            </div>
          ))}

          {conjunctionsGames?.map((game) => (
            <div
              key={game.gameId}
              className="conjunctions-game"
              onClick={() => {
                // 联想词点击上报-游戏
                sessionStorage.removeItem("boardInputFont");
                setBoardkw("");
                setType(1);
                setGamekw(
                  game.mainName + (game.secondName && `-${game.secondName}`),
                );
                setClassifyId("");

                // 3级输入搜索词、4级点击搜索联想词同时上报
                searchAssociationClick("游戏", {
                  mainName:
                    game.mainName + (game.secondName && `-${game.secondName}`),
                  status: game.status,
                });
              }}
            >
              <span className="conjunctions-game-name">
                {game.mainName}
                {game.secondName && `-${game.secondName}`}
              </span>

              {game.searchTag && (
                <img
                  className="conjunctions-game-tag"
                  src={`/resources/search/${
                    game.searchTag == "热玩"
                      ? "hot"
                      : game.searchTag == "最新"
                        ? "new"
                        : "recommend"
                  }.png`}
                  alt=""
                />
              )}
            </div>
          ))}

          {/* 关联词列表加载更多触发元素 */}
          {conjunctionsGames?.length > 0 && conjunctionsMore && (
            <div
              ref={setConjunctionsLoadMoreRef}
              style={{
                height: "20px",
                width: "100%",
                background: "transparent",
              }}
            />
          )}
        </div>
      )}

      {gamekw && (
        <div
          className="apply-new-game"
          onClick={() => {
            applyName = "";
            setApplyName("");
            setApplyShow(true);
          }}
        >
          <span className="font">申请新游戏</span>
          <img src="/resources/search/right.png" alt="" className="icon" />
        </div>
      )}

      {applyShow && (
        <div className="apply-container">
          <div
            className="apply-mask"
            onClick={() => {
              setApplyShow(false);
            }}
          />

          <div className="apply-main">
            <div className="apply-title">告诉我们，你想要的</div>
            <div className="apply-game-dialog">
              <div className="apply-input-box">
                <input
                  className="apply-input"
                  type="text"
                  placeholder="请输入游戏名称"
                  value={applyName}
                  onChange={(e) => {
                    applyName = e.target.value;
                    setApplyName(e.target.value);
                    console.log(applyName);
                  }}
                />

                {applyName && (
                  <CloseOutlined
                    style={{
                      fontSize: "16px",
                      color: "#999",
                    }}
                    onClick={() => {
                      applyName = "";
                      setApplyName("");
                    }}
                  />
                )}
              </div>

              <div className="tips-font">
                输入心仪的游戏名称，我们会根据您的意见更新游戏
              </div>
            </div>
            <div className="apply-btn" onClick={submitLikeGame}>
              提交
            </div>
          </div>

          <div
            className="apply-close"
            onClick={() => {
              applyName = "";
              setApplyName("");
              setApplyShow(false);
            }}
          >
            <img src="/resources/game/close.png" alt="" />
          </div>
        </div>
      )}
    </div>
  );
};
